import type { ECompanyFilterType } from '@/shared/api/generated';

/** Valores nomeados de `ECompanyFilterType` (o tipo gerado é só `1 | 2 | 3`). */
export const SERIE_COMPANY_FILTER_TYPE = {
  Main: 1,
  Company: 2,
  All: 3,
} as const satisfies Record<string, ECompanyFilterType>;

/** Filtros (server-side) da listagem de Séries. */
export interface SerieFilters {
  readonly search: string;
  readonly page: number;
  /** Origem das séries: Acadêmico Pecege (`Main`), Empresa (`Company`) ou Todos (`All`). */
  readonly filter: ECompanyFilterType;
  /** ID da empresa selecionada; só relevante quando `filter === Company`. */
  readonly companyId: number | undefined;
}

export const INITIAL_SERIE_FILTERS: SerieFilters = {
  search: '',
  page: 1,
  filter: SERIE_COMPANY_FILTER_TYPE.All,
  companyId: undefined,
};
